// src/components/register/ImageSelector.tsx
import React from 'react';
import { VISION_IMAGE_OPTIONS, type VisionImageKey } from '../../types/registration';
import visionImage1 from '../../assets/vision_image1.png';
import visionImage2 from '../../assets/vision_image2.png';
import visionImage3 from '../../assets/vision_image3.png';
import visionImage4 from '../../assets/vision_image4.png';
import visionImage5 from '../../assets/vision_image5.png';
import visionImage6 from '../../assets/vision_image6.png';

// 画像ファイルのマッピング
const IMAGE_MAP: Record<VisionImageKey, string> = {
  vision_image1: visionImage1,
  vision_image2: visionImage2,
  vision_image3: visionImage3,
  vision_image4: visionImage4,
  vision_image5: visionImage5,
  vision_image6: visionImage6,
};

interface ImageSelectorProps {
  selectedImage: VisionImageKey;
  onSelectImage: (imageKey: VisionImageKey) => void;
}

export const ImageSelector: React.FC<ImageSelectorProps> = ({ selectedImage, onSelectImage }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {VISION_IMAGE_OPTIONS.map((option) => {
        const isSelected = selectedImage === option.value;
        const imageUrl = IMAGE_MAP[option.value];

        return (
          <div
            key={option.value}
            onClick={() => onSelectImage(option.value)}
            className={`relative cursor-pointer rounded-lg border-2 overflow-hidden transition-all ${
              isSelected
                ? 'border-yellow-500 ring-2 ring-yellow-500 ring-offset-2'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="aspect-video bg-gray-100">
              <img src={imageUrl} alt={option.label} className="w-full h-full object-cover" />
            </div>

            <div
              className={`p-2 text-center text-sm font-medium ${
                isSelected ? 'bg-yellow-50 text-yellow-900' : 'bg-white text-gray-700'
              }`}
            >
              {option.label}
            </div>

            {isSelected && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
